
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.653.542c-.82 0-1.483.647-1.483 1.445v5.278C25.532.063 13.35.255 5.956 7.695 2.473 11.2.53 15.89.54 20.77c0 .799.664 1.445 1.483 1.445.82 0 1.483-.646 1.483-1.445.002-8.777 7.308-15.892 16.319-15.89 4.576 0 8.942 1.874 12.031 5.162l-6.57 2.134c-.778.252-1.2 1.071-.94 1.83.259.758 1.1 1.168 1.877.915l8.9-2.89a1.449 1.449 0 001.014-1.375v-8.67c0-.797-.664-1.444-1.483-1.444z","fill":"#1B3067"}})])
          )
        }
      }
    